<template>
    <div class="bg-white min-h-screen">
        <header class="bg-gray-50 shadow">
            <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8">
                <div class="relative h-16 flex justify-between">
                    <div class="relative z-10 px-2 flex lg:px-0">
                        <div class="flex-shrink-0 flex items-center">
                            <inertia-link :href="$route('home')">
                                <img alt="Logo" class="block h-8 w-auto" src="/images/logo.png" />
                            </inertia-link>
                        </div>
                    </div>
                    <div class="relative z-10 ml-4 flex items-center">
                        <inertia-link
                            download
                            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            :href="$route('gestion.build.show', $page.props.account.sid)"
                            v-if="isLogged"
                        >
                            {{ $t('menu.preview.edit') }}
                        </inertia-link>
                        <template v-if="!isLogged">
                            <inertia-link
                                class="w-full flex justify-center py-2 px-4 border border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-500  hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                :href="$route('setup', $page.props.account.sid)"
                            >
                                {{ $t('menu.preview.edit') }}
                            </inertia-link>
                            <inertia-link
                                class="ml-4 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                :href="$route('signup', $page.props.account.sid)"
                            >
                                {{ $t('menu.preview.finish') }}
                            </inertia-link>
                        </template>

                    </div>
                </div>
            </div>
        </header>
        <main class="max-w-7xl mx-auto pb-10">
            <slot />
        </main>
    </div>
</template>

<script>
    export default {
        data: () => ({
            menuIsOpen: false,
        }),

        computed: {
            isLogged() {
                return !!this.$page.props.auth.user;
            },
        },

        methods: {
            toggleMenu() {
                this.menuIsOpen = !this.menuIsOpen;
            },
        },
    };
</script>
